import { useContext, useEffect, useState } from 'react';
import usePrevious from '../../../../hooks/usePrevious';
import { ListerContext } from '../../listerContext';

const useVisiblePages = (): any => {
  const [
    {
      pagination: { numberOfPages, currentPage, sort },
      breadcrumbs
    }
  ] = useContext(ListerContext);
  const [firstVisiblePage, setFirstVisiblePage] = useState(currentPage);
  const [lastVisiblePage, setLastVisiblePage] = useState(currentPage);
  const prevSort = usePrevious(sort);

  useEffect(() => {
    if (numberOfPages < lastVisiblePage) {
      setLastVisiblePage(numberOfPages);
    }
  }, [numberOfPages, lastVisiblePage]);

  useEffect(() => {
    if (numberOfPages < firstVisiblePage) {
      setFirstVisiblePage(numberOfPages);
    }
  }, [numberOfPages, firstVisiblePage]);

  useEffect(() => {
    if (prevSort && sort) {
      setFirstVisiblePage(1);
      setLastVisiblePage(1);
    }
  }, [breadcrumbs.length, sort]);

  return {
    firstVisiblePage,
    lastVisiblePage,
    setFirstVisiblePage,
    setLastVisiblePage
  };
};

export default useVisiblePages;
